import { defaults as defaultControls, ScaleLine } from 'ol/control';
import TileLayer from 'ol/layer/Tile';
import Map from 'ol/Map';
import XYZ from 'ol/source/XYZ';
import View from 'ol/View';

export const mapFactory = (mapRef: React.RefObject<HTMLDivElement>) => {
  const baseUrl =
    'https://atlas.microsoft.com/map/tile?zoom={z}&x={x}&y={y}&tileSize=256&language=EN&&api-version=2.0';
  const subscriptionKey =
    'EFEZkBexprHPwEHyJIWx3eZlQft2pYB2BJOOTGd1fcztIOZezJOAJQQJ99BIACi5YpzLgpE8AAAgAZMP4UFN';

  const map = new Map({
    controls: defaultControls().extend([
      new ScaleLine({
        units: 'metric',
        bar: false,
        text: true,
        minWidth: 140,
      }),
    ]),
    target: mapRef.current || undefined,
    layers: [
      new TileLayer({
        source: new XYZ({
          url: `${baseUrl}&subscription-key=${subscriptionKey}&tilesetId=microsoft.imagery`,
          crossOrigin: 'anonymous',
          attributions: `© ${new Date().getFullYear()} TomTom, Microsoft`,
        }),
      }),
    ],
    view: new View({
      center: [4185385.9208, 3921831.0473],
      zoom: 7,
    }),
  });
  return map;
};
